// extracted by mini-css-extract-plugin
module.exports = {"carousel":"CustomCarousel_carousel__irmil","item":"CustomCarousel_item__33qxE"};